__turbopack_context__.v({
  "variants": "DemoContentLoading-module__mgqr6a__variants",
});
